/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Desenvolvido pelo Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Impulsionado pelo AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated':
    'Utiliza a inteligência artificial Verifique os resultados.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informações',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Inclua conhecimento da página atual',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logotipo da Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Voltar',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Cancelar',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Cancelar',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Cancelar',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Resposta ruim',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback enviado',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Boa resposta',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Continuar a partir da última resposta',
  'fabric.editor.ai.config.item.action.copyResponse': 'Copiar',
  'fabric.editor.ai.config.item.action.responseCopied': 'Copiado!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copiado para a área de transferência',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Tentar de novo',
  'fabric.editor.ai.experience-application.documentInsertError':
    'A gente está com problemas para inserir a resposta. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Não foi possível obter uma resposta. A solicitação ou resposta estava acima do limite dessa solicitação. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience.apiError': 'Não foi possível obter uma resposta. Tente de novo.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': 'Diga à IA o que fazer...',
  'fabric.editor.ai.experience.inlineCommentLoadingAnalyzing': 'Analisando',
  'fabric.editor.ai.experience.inlineCommentLoadingEditingTitle': 'Edição',
  'fabric.editor.ai.experience.inputTooShortError':
    'O conteúdo é curto demais para ser resumido. Adicione mais e tente de novo.',
  'fabric.editor.ai.experience.loadingAnalyzing': 'O Rovo está analisando',
  'fabric.editor.ai.experience.loadingAriaNewTitle': 'O Rovo está trabalhando nisso',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Gerando',
  'fabric.editor.ai.experience.loadingChangingTone': 'O Rovo está alterando o tom',
  'fabric.editor.ai.experience.loadingEditingTitle': 'O Rovo está editando',
  'fabric.editor.ai.experience.loadingFixingSpellingAndGrammar': 'O Rovo está corrigindo a ortografia e a gramática',
  'fabric.editor.ai.experience.loadingLengthening': 'O Rovo está aumentando',
  'fabric.editor.ai.experience.loadingPolishing': 'O Rovo está polindo',
  'fabric.editor.ai.experience.loadingShortening': 'O Rovo está encurtando',
  'fabric.editor.ai.experience.loadingSummarizing': 'O Rovo está resumindo',
  'fabric.editor.ai.experience.loadingTranslating': 'O Rovo está traduzindo',
  'fabric.editor.ai.experience.previewScreenLabel': 'Pré-visualizar',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Diga ao agente algo para escrever ou escolha uma das opções abaixo',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logotipo do Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.acceptReject.acceptLabel': 'Aceitar',
  'fabric.editor.ai.screens.acceptReject.rejectLabel': 'Descartar',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Voltar',
  'fabric.editor.ai.screens.discard.discardLabel': 'Descartar',
  'fabric.editor.ai.screens.discard.noLabel': 'Não',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Aviso',
  'fabric.editor.ai.screens.discard.yesLabel': 'Sim',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Erro',
  'fabric.editor.ai.screens.error.cancelLabel': 'Cancelar',
  'fabric.editor.ai.screens.error.closeLabel': 'Fechar',
  'fabric.editor.ai.screens.error.retryLabel': 'Tentar de novo',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Conteúdo de atualização ao vivo:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Ícone de geração',
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': 'Nada a melhorar, bom trabalho.',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': 'Sucesso',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Aceitar',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Ações para conteúdos gerados por IA',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Tentar de novo',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Cancelar',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'Útil?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Diga ao AI o que fazer a seguir',
  'fabric.editor.ai.screens.preview.defaultRovoInputPlaceholder': 'Diga ao Rovo o que fazer a seguir',
  'fabric.editor.ai.screens.preview.discardLabel': 'Descartar',
  'fabric.editor.ai.screens.preview.disclaimer': 'A qualidade das informações pode variar.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Saiba por que',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Limpar',
  'fabric.editor.ai.screens.preview.header.edit': 'Editar prompt',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Editar',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Pergunte a {agentName} o que fazer a seguir',
  'fabric.editor.ai.screens.preview.refineButton': 'Refinar',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Refinar',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logotipo da Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.inlineCommentPlaceholder': 'Descreva o que fazer',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'Adicionar link',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'Mencionar usuário',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'Inserir conteúdo avançado',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': 'Descreva o que você quer fazer',
  'fabric.editor.ai.screens.prompt.streaming.record': 'Gravar',
  'fabric.editor.ai.screens.prompt.streaming.submit': 'Enviar',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Enviar',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Enviar para o AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} selecionado',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Remover',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Sugestões',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Assistente de redação',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Deixe o Atlassian Intelligence ajudar você a escrever',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Escrever',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.shared.generateContent.rovoButtonTitle': 'Pergunte ao Rovo',
  'fabric.editor.ai.shared.rovoUniversalLongCallToAction': 'Colabore com a IA',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOVIDADE',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Diga ao AI:',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Diga ao agente',
};
